import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { directoryApi, type CertificationCatalogue } from '../client';

/**
 * Stable query-key factory for the static certification catalogue. Single
 * top-level key — the catalogue is the same for every tenant.
 */
export const certificationCatalogueKeys = {
  all: ['directory', 'certification-catalogue'] as const,
};

/**
 * Fetch the static certification catalogue (12 cert kinds with their
 * applies-to + per-country availability metadata).
 *
 * Cached for 24h — the catalogue is bundled JSON on the BE, only changes
 * on deploy. The Resources page picker filters certs per resource type
 * by walking `appliesTo`, so this is a hot read.
 */
export function useCertificationCatalogue(
  options?: Omit<UseQueryOptions<CertificationCatalogue, Error>, 'queryKey' | 'queryFn'>,
) {
  return useQuery<CertificationCatalogue, Error>({
    queryKey: certificationCatalogueKeys.all,
    queryFn: () => directoryApi.getCertificationCatalogue(),
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: Infinity,
    ...options,
  });
}
